// src/hooks/useTopPackages.ts
import { useMemo } from "react";
import { useSubscriptionsStore } from "../store/subscriptions";
import { BillingSubscription } from "../../../types/subscription";


export interface PackageStats {
  packageName: string;
  subscribers: number;
  totalRevenue: number;
}

export function useTopPackages(): PackageStats[] {
  const { subscriptions } = useSubscriptionsStore();

  return useMemo(() => {
    if (!subscriptions || subscriptions.length === 0) return [];

    const packageMap: Record<string, { subscribers: number; revenue: number }> = {};

    subscriptions.forEach((sub: BillingSubscription) => {
      if (sub.status.toLowerCase() !== "paid") return;

      const price = Number(sub.price) || 0;
      const pkg = sub.package_name || "Unknown Package";

      if (!packageMap[pkg]) {
        packageMap[pkg] = { subscribers: 0, revenue: 0 };
      }

      packageMap[pkg].subscribers += 1;
      packageMap[pkg].revenue += price;
    });

    return Object.entries(packageMap)
      .map(([packageName, stats]) => ({
        packageName,
        subscribers: stats.subscribers,
        totalRevenue: stats.revenue,
      }))
      .sort((a, b) => b.subscribers - a.subscribers)
      .slice(0, 6);
  }, [subscriptions]);
}
